import { EActions } from './EActions';
import * as MeService from '../../services/me.service';
import { Dispatch } from 'redux';

export function GetMe() {
  return async (dispatch: Dispatch) => {
    try {
      const result = await MeService.GetMe();
      dispatch(GetMeSuccess(result));
      return result;
    } catch (error) {
      dispatch(GetMeFail(error as any));
      return Promise.reject(error);
    }
  };
}

export function GetMeSuccess(data: any) {
  return {
    type: EActions.MeSuccess,
    payload: data,
  };
}

function GetMeFail(error: string) {
  return {
    type: EActions.MeFail,
    payload: error,
  };
}

export function UpdateProfile(data: MeService.PutMeRequest) {
  return async (dispatch: Dispatch) => {
    dispatch({ type: EActions.UpdateMe });
    try {
      const result = await MeService.UpdateMe(data);
      dispatch(UpdateMeSuccess(result));
      return result;
    } catch (error) {
      dispatch(UpdateMeFail(error as any));
      return Promise.reject(error);
    }
  };
}

export function PatchProfile(data: MeService.PatchMeRequest) {
  return async (dispatch: Dispatch) => {
    dispatch({ type: EActions.UpdateMe });
    try {
      const result = await MeService.PatchMe(data);
      dispatch(UpdateMeSuccess(result));
      return result;
    } catch (error) {
      dispatch(UpdateMeFail(error as any));
      return Promise.reject(error);
    }
  };
}

export function UpdateMeSuccess(data: any) {
  return {
    type: EActions.UpdateMeSuccess,
    payload: data,
  };
}

function UpdateMeFail(error: string) {
  return {
    type: EActions.UpdateMeFail,
    payload: error,
  };
}
